import styled from 'styled-components';
import { useNavigation } from '~/common/hooks/useNavigation';
import { fontFamilies } from '~/theme/typography';

export const NotFoundPage = () => {
  const { goToShop } = useNavigation();

  return (
    <NotFoundWrapper>
      <NotFoundContainer>
        <ContentBox>
          <Title>404</Title>
          <Subtitle>Page Not Found</Subtitle>
          <ButtonWrapper>
            <ShopButton onClick={goToShop}>Continue shopping</ShopButton>
          </ButtonWrapper>
        </ContentBox>
      </NotFoundContainer>
    </NotFoundWrapper>
  );
};

const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100svh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.colorMain};
`;

const NotFoundContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 60.5rem;
  padding: 68px 40px 40px 40px;
  height: 100%;

  @media ${({ theme }) => theme.breakpoints.lg} {
    max-width: 59.5rem;
    padding: 68px 32px 40px 32px;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    padding: 68px 24px 40px 24px;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 68px 16px 24px 16px;
  }
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 100%;
  }
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-family: ${fontFamilies.PantonRustHeavy};
  font-size: 100px;
  font-weight: 100;
  line-height: normal;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 48px;
    letter-spacing: 0.24px;
  }
`;

const Subtitle = styled.h2`
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-family: ${fontFamilies.PantonRustHeavy};
  font-size: 40px;
  font-weight: 100;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  margin: 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 32px;
    letter-spacing: 0.16px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 24px;
  width: fit-content;

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 100%;
  }
`;

const ShopButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.white};
  padding: 0 12px;
  cursor: pointer;
  white-space: nowrap;

  color: ${({ theme }) => theme.colors.colorMain};
  font-family: ${fontFamilies.CircularStd};
  font-size: 16px;
  font-weight: 450;
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 100%;
  }
`;
